import { CommonModule, isPlatformBrowser } from '@angular/common';
import { InjectionToken, NgModule, PLATFORM_ID } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { RouterModule, Routes } from '@angular/router';
import { PLPRepository } from '@core/services/repositories/plp.repository';
import { StickySearchboxComponent } from '@shared/components/sticky-searchbox/sticky-searchbox.component';
import { SharedModule } from '@shared/shared.module';
import { EmptyViewComponent } from './components/empty-view/empty-view.component';
import { FiltersSidebarDesktopComponent } from './components/filters-sidebar-desktop/filters-sidebar-desktop.component';
import { PriceFilterComponent } from './components/filters/price-filter/price-filter.component';
import { ResidenceFilterComponent } from './components/filters/residence-filter/residence-filter.component';
import { SortFilterComponent } from './components/filters/sort-filter/sort-filter.component';
import { PlpBreadcrumbComponent } from './components/plp-breadcrumb/plp-breadcrumb.component';
import { PlpCardsSkeletonComponent } from './components/plp-cards-skeleton/plp-cards-skeleton.component';
import { PlpCardsComponent } from './components/plp-cards/plp-cards.component';
import { PlpFaqComponent } from './components/plp-faq/plp-faq.component';
import { PlpMapComponent } from './components/plp-map/plp-map.component';
import { PlpPageHeaderComponent } from './components/plp-page-header/plp-page-header.component';
import { SideFiltersComponent } from './components/side-filters/side-filters.component';
import { SortFilterDeskComponent } from './components/sort-filter-desktop/sort-filter-desktop.component';
import { searchResultResolver } from './guards/search-result.resolver';
import { SearchResultComponent } from './search-result.component';
import { SearchResultUiService } from './services/search-result-ui.service';
import { DesktopSearchboxComponent } from './components/desktop-searchbox/desktop-searchbox.component';
import { MobileSearchboxComponent } from './components/mobile-searchbox/mobile-searchbox.component';
import { PlpRefreshAlertComponent } from './components/plp-refresh-alert/plp-refresh-alert.component';
import { BottomNavMobileComponent } from '../home/components/bottom-nav-mobile/bottom-nav-mobile.component';
import { RelatedlinksComponent } from './components/relatedlinks/relatedlinks.component';
import { AccommodationFacilitiesComponent } from './components/filters/accommodation-facilities/accommodation-facilities.component';
import { TypeOfLocationComponent } from './components/filters/type-of-location/type-of-location.component';
import { PaginationComponent } from "../../shared/components/pagination/pagination.component";
import { RulesFilterComponent } from './components/filters/rules-filter/rules-filter.component';

const routes: Routes = [
 {
  path: '',
  component: SearchResultComponent,
  resolve: { data: searchResultResolver },
  runGuardsAndResolvers: 'always',
  children: [
   {
    path: 'map',
    loadComponent: () =>
     import('../../shared/components/map/map.component').then((m) => m.MapComponent),
   },
  ],
 },
];

export const WINDOW = new InjectionToken<Window>('Window', {
 factory: () => window,
});

export const DOCUMENT = new InjectionToken<Document>('Document', {
 factory: () => document,
});

@NgModule({
 imports: [
    CommonModule,
    RouterModule.forChild(routes),
    SharedModule,
    PlpCardsComponent,
    PlpBreadcrumbComponent,
    PlpMapComponent,
    PlpPageHeaderComponent,
    PlpCardsSkeletonComponent,
    FiltersSidebarDesktopComponent,
    SideFiltersComponent,
    SortFilterDeskComponent,
    SortFilterComponent,
    MatDialogModule,
    PriceFilterComponent,
    TypeOfLocationComponent,
    AccommodationFacilitiesComponent,
    RulesFilterComponent,
    EmptyViewComponent,
    ResidenceFilterComponent,
    StickySearchboxComponent,
    PlpFaqComponent,
    DesktopSearchboxComponent,
    MobileSearchboxComponent,
    PlpRefreshAlertComponent,
    RelatedlinksComponent,
    BottomNavMobileComponent,
    PaginationComponent
],
 declarations: [SearchResultComponent],
 providers: [
  PLPRepository,
  SearchResultUiService,
  {
   provide: WINDOW,
   useFactory: (platformId: Object) => {
    return isPlatformBrowser(platformId) ? window : {};
   },
   deps: [PLATFORM_ID],
  },
  {
   provide: DOCUMENT,
   useFactory: (platformId: Object) => {
    return isPlatformBrowser(platformId) ? document : {};
   },
   deps: [PLATFORM_ID],
  },
 ],
})
export class SearchResultModule {}
